<template>
  <div class="top-products">
    <horizontal-bar-chart :chart-data="chartData"></horizontal-bar-chart>
  </div>
</template>
<script>
import HorizontalBarChart from "@/components/admin/dashboard/charts/HorizontalBarChart";
import chartMixin from "@/mixins/dashboard/chartMixin";
export default {
  name: "EmailRanking",
  components: { HorizontalBarChart },
  mixins: [chartMixin],
  props: {
    payments: {
      type: Array,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    chartData() {
      let labels = [];
      let data = [];
      let _payments = this.payments.reduce(function(acc, curr) {
        return (
          curr.email
            ? acc[curr.email]
              ? ++acc[curr.email]
              : (acc[curr.email] = 1)
            : "",
          acc
        );
      }, {});
      for (const [key, value] of Object.entries(_payments)) {
        labels.push(key);
        data.push(value);
      }
      return {
        labels: labels,
        datasets: [
          {
            label: "No. of orders",
            data: data,
            fill: false,
            backgroundColor: "#02e0fd",
            borderColor: "#000000",
            pointBorderColor: "white",
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
